module.exports = __webpack_public_path__ + "img/CF_1O.1ae37983.jpg";